export const MAX_HOME_SERVICES_INITIAL_DESCRIPTION = 200; // Number of characters to show before truncating in home's service section
export const MAX_SERVICES_PAGE_INITIAL_DESCRIPTION = 500; // Number of characters to show before truncating in services page
